










import { defineComponent, ref } from "@vue/composition-api";
import { AgeVerificationStatus } from "@scrile/api-provider/dist/api/AgeVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import { useAgeVerification } from "@/features/age-verification";
import AgeVerificationSetup from "./components/AgeVerificationSetup";
import { EVENTS as AGE_VERIFICATION_EVENTS } from "../../const";

export default defineComponent({
  name: "AgeVerification",
  components: { AgeVerificationSetup },
  setup(_, { emit }) {
    const { authUser } = useAuthUser();
    const { status, get, reset } = useAgeVerification();

    const showSetup = ref(false);
    const processing = ref(false);

    const onCancel = () => {
      showSetup.value = false;
      emit("close");
    };

    const onFinish = () => {
      showSetup.value = false;
      emitter.emit(AGE_VERIFICATION_EVENTS.AGE_VERIFICATION_STATUS_CHANGED);
      emit("close");
    };

    const onReset = async () => {
      await reset();
      showSetup.value = false;
      emit("close");
    };

    const getData = async () => {
      if (!authUser.value) {
        emitter.emit(EVENTS.SHOW_LOGIN_SIGNUP_MODAL, { showLogin: true });
        emit("close");
        return;
      }
      await get();
      if ([AgeVerificationStatus.UNKNOWN, AgeVerificationStatus.DENIED].includes(status.value)) {
        showSetup.value = true;
      } else if (status.value === AgeVerificationStatus.APPROVED) {
        emit("close", true);
      } else {
        emit("close");
      }
    };

    getData();

    return {
      showSetup,
      processing,
      onCancel,
      onFinish,
      onReset,
    };
  },
});
